<div class="budget-table-controls">
  <button *ngIf="editableBudget" class="add-segment" (click)="addSegment.emit()">
    <fa-duotone-icon [icon]="['fad', 'plus-circle']"></fa-duotone-icon>
    Add Segment
  </button>

  <button class="toggle-projected" (click)="toggleProjected()" *ngIf="!isForecastActive">
    <fa-duotone-icon [icon]="['fad', showProjected ? 'eye-slash' : 'eye']"></fa-duotone-icon>
    {{ showProjected ? 'Hide' : 'Show' }} Projected Budget
  </button>

  <button class="toggle-projected" [ngClass]="{'hide-forecast-toggle': isForecastActive}" (click)="toggleForecast()" *ngIf="isForecastActive">
    <fa-duotone-icon [icon]="['fad', !showForecast ? 'eye-slash' : 'eye']"></fa-duotone-icon>
    {{ !showForecast ? 'Hide' : 'Show' }} Forecast
  </button>
</div>
